import { httpsCallable } from 'firebase/functions';
import { appId, functions } from '@/lib/firebase';

const DEFAULT_MONTHLY_WARRIOR_COUNT = 847;

export async function fetchMonthlyWarriorCount(): Promise<number> {
  try {
    const call = httpsCallable(functions, 'getPublicImpactCounters');
    const result = await call({ appId });
    const data = result.data as { success?: boolean; monthlyWarriorCount?: number };
    const count = data.monthlyWarriorCount;
    if (typeof count === 'number' && Number.isFinite(count) && count > 0) {
      return Math.floor(count);
    }
  } catch (error) {
    console.warn(
      `[fetchMonthlyWarriorCount] Failed to load monthly warrior count for app "${appId}":`,
      error
    );
  }
  return DEFAULT_MONTHLY_WARRIOR_COUNT;
}

export function formatMonthlyWarriorSocialProof(count: number): string {
  const formatted = new Intl.NumberFormat('en-US').format(count);
  return `Join ${formatted} monthly donors already keeping patients alive.`;
}
